module.exports = __webpack_public_path__ + "static/media/react.82c92992.jpg";